module.exports = __webpack_public_path__ + "img/delivery-box.1222d252.svg";